const organizationTemplateState = Object.freeze({
  full: 'Full',
  partial: 'Partial',
  none: 'None',
});

export default organizationTemplateState;
